import { useUiStore } from './uiStore';

export function Toaster() {
  const toast = useUiStore((s) => s.toast);
  if (!toast) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      key={toast.id}
      className={`fixed bottom-[calc(18px+env(safe-area-inset-bottom,0px))] left-1/2 z-30 max-w-[calc(100%-32px)] -translate-x-1/2 rounded-full px-5 py-3 text-[15px] font-semibold shadow-lg ${
        toast.tone === 'warn' ? 'bg-warn text-bg' : 'bg-fg text-bg'
      }`}
    >
      {toast.message}
    </div>
  );
}
